import { celebrate } from '@/stores/welcome.store';
import { useLocation, useNavigate } from '@solidjs/router';
import { onCleanup, onMount } from 'solid-js';

// UCH-427: Ctrl+Alt+W (or Alt+Shift+W) anywhere replays the full Welcome
// (banner + celebration) on /profile, so the flow is debuggable without a
// fresh account. Mounted at the router root so it works on every route.
//
// Matching is deliberately loose: on macOS Option+W makes e.key '∑', so the
// physical e.code is the reliable signal, and two combos means one being
// swallowed by the OS/browser still leaves a way in.
export function WelcomeDebugShortcut() {
  const navigate = useNavigate();
  const location = useLocation();

  const trigger = () => {
    celebrate({ forced: true });
    if (location.pathname !== '/profile') navigate('/profile');
  };

  onMount(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.repeat || !e.altKey || (!e.ctrlKey && !e.shiftKey)) return;
      if (e.code !== 'KeyW' && e.key?.toLowerCase() !== 'w') return;
      e.preventDefault();
      trigger();
    };
    window.addEventListener('keydown', onKey);
    onCleanup(() => window.removeEventListener('keydown', onKey));
  });

  return null;
}
